export default "__VITE_ASSET__73384123__"